var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{staticClass:"home-container"},[_c('el-aside',{attrs:{"width":_vm.isOpen ? '64px' : '200px'}},[_c('menus')],1),_c('el-main',{staticStyle:{"height":"100vh","overflow":"hidden"}},[_c('right-main')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }